import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { Form, Input, Select } from "antd";
import toast from "react-hot-toast";
import banc from "../../../../assets/images/banc.png";
import mobiles from "../../../../assets/images/mobiles.png";
import { getPaymentMethodByCountry } from "../../../admin/business/services/developerApi";
import { addCompte } from "../../services/merchandApi";
import { useQueryClient } from "react-query";
const NewCompte = ({ show, onClose  }) => {
  const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));
  const currentAdminId = currentUser?.user?.id;
  const [selected, setSelected] = useState(null);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
   const getCardStyle = (type, isActive = false) => ({
    width: "100%",
    minHeight: "72px",
    border: (selected === type || isActive)
      ? "2px solid #3761FF"
      : "1px solid #E3E3E3",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    padding: "0 15px",
    backgroundColor: (selected === type || isActive) ? "#E9F0FF" : "#FFFFFF",
    fontFamily: "Poppins",
    color: "#333",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  });
  const ownerFullName = `${currentUser?.user?.firstName || ""} ${currentUser?.user?.lastName || ""}`.trim() || "Titulaire";
  const queryClient = useQueryClient();
const handleAddCompte = async () => {
  if (!countryCode || !phone || !selectedMethod) {
    toast.error("Veuillez remplir tous les champs");
    return;
  }
  const payload = {
    merchantId: currentAdminId,
    ownerFullName,
    prefixCode: countryCode.replace("+", ""),
    phoneNumber: phone,
    paymentMethod: selectedMethod,
    countryCode: prefixToCountry[countryCode],
    type: "PAYOUT",
    createdAt: Date.now(),
  };
  try {
    await addCompte(payload);
    toast.success("Compte créé avec succès 🎉");
     queryClient.invalidateQueries(["comptes", currentAdminId]);
    onClose?.();
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Erreur lors de la création"
    );
  }
};
   const countryFlags = {
    SN: "https://flagcdn.com/w40/sn.png",
    CI: "https://flagcdn.com/w40/ci.png",
    BF: "https://flagcdn.com/w40/bf.png",
    BJ: "https://flagcdn.com/w40/bj.png",
    NE: "https://flagcdn.com/w40/ne.png",
    ML: "https://flagcdn.com/w40/ml.png",
    GN: "https://flagcdn.com/w40/gn.png",
    TG: "https://flagcdn.com/w40/tg.png",
    CM: "https://flagcdn.com/w40/cm.png",
    CD: "https://flagcdn.com/w40/cd.png",
  };
    const countryCodes = {
    SN: "+221",
    CI: "+225",
    BF: "+226",
    BJ: "+229",
    NE: "+227",
    ML: "+223",
    GN: "+224",
    TG: "+228",
    CM: "+237",
    CD: "+243",
  };
const prefixToCountry = {
  "+221": "SN",
  "+225": "CI",
  "+226": "BF",
  "+229": "BJ",
  "+227": "NE",
  "+223": "ML",
  "+224": "GN",
  "+223": "TG",
  "+237": "CM",
  "+243": "CD",
};
useEffect(() => {
  if (!countryCode) return;

  const detectedCountry = prefixToCountry[countryCode];
  if (!detectedCountry) return;

  const fetchMethods = async () => {
    try {
      const methods = await getPaymentMethodByCountry(detectedCountry);
      setPaymentMethods(methods || []);
    } catch (e) {
      setPaymentMethods([]);
    }
  };

  fetchMethods();
}, [countryCode]);
  return (
    <Modal
      open={show}
      onCancel={onClose}
      footer={null}
      centered
      width="20%"
      style={{ borderRadius: "12px" }}
      destroyOnClose
    >
      <div className="mx-auto text-center mb-4"style={{ fontSize: "19px", color: "#000000",fontFamily:'Poppins', marginBottom: "2px", fontWeight: "500" }}>
      Ajouter un nouveau compte
      </div>
      <div
          className=" mt-1"
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
        <div className="mt-1" >
          <Form.Item className="normal" layout="vertical" style={{ marginBottom: "10px" }}>
            <div  style={getCardStyle("mobile")}onClick={() => {setSelected("mobile");setPaymentMethods([]);setSelectedMethod(null);}}>
              <img src={mobiles} alt="Mobile" style={{ width: "36px", height: "36px", marginRight: "15px" }} />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "14px", color: "#454545",fontFamily:'Poppins', marginBottom: "2px", fontWeight: "400" }}>
                  Mobile Money
                </span>
                <span style={{ fontSize: "12px", color: "#454545", fontWeight: "400",fontFamily:'Poppins' }}>
                  Orange Money, MTN, Moov, ...
                </span>
              </div>
            </div>
          </Form.Item>
        </div>
        <div className=" mt-1">
          <Form.Item className="normal" layout="vertical" style={{ marginBottom: "10px" }}>
            <div style={getCardStyle("bank")} >
              <img src={banc} alt="Banque" style={{ width: "36px", height: "36px", marginRight: "15px" }} />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "14px", color: "#454545",fontFamily:'Poppins', marginBottom: "2px", fontWeight: "400" }}>
                  Compte bancaire
                </span>
                <span style={{ fontSize: "12px", color: "#454545",fontFamily:'Poppins', marginBottom: "2px", fontWeight: "400" }}>
                  Virement bancaire
                </span>
              </div>
            </div>
          </Form.Item>
        </div>
      </div>
     {selected === "mobile" && (
  <div className="mt-3">
    
    <Form.Item label="Saisir le numéro" layout="vertical">
      <Input.Group compact>
        <Select
          value={countryCode}
          onChange={(value) => setCountryCode(value)}
          style={{ width: "30%" }}
          placeholder="+221"
        >
          {Object.entries(countryCodes).map(([code, prefix]) => (
            <Select.Option key={code} value={prefix}>
              <img
                src={countryFlags[code]}
                alt={code}
                width="20"
                style={{ marginRight: 6 }}
              />
              {prefix}
            </Select.Option>
          ))}
        </Select>

        <Input
          style={{ width: "65%" }}
          placeholder="Numéro"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </Input.Group>
    </Form.Item>
    {paymentMethods.length > 0 && (
      <div className="d-flex flex-wrap gap-2 mt-2">
        {paymentMethods.map((method) => (
          <div
            key={method.id}
            onClick={() => setSelectedMethod(method.id)}
            style={{
              border: selectedMethod === method.id
                ? "2px solid #3761FF"
                : "1px solid #E3E3E3",
              borderRadius: "8px",
              padding: "10px",
              width: "90px",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={method.urlLogo || "/default-logo.png"}
              alt={method.name}
              style={{ width: "30px", marginBottom: "5px" }}
            />
            <div style={{ fontSize: "12px" }}>{method.name}</div>
          </div>
        ))}
      </div>
    )}
  </div>
)}
<div
  className="container-kyc kyc-responsive"
  style={{ display: "flex", gap: "30px", marginTop: "20px" }}
>
  <button
  type="button"
  onClick={handleAddCompte}
  style={{
    width: "100%",
    padding: "5px 20px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#3761FF",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
  }}
>
  Ajouter
</button>
</div>
    </Modal>
  );
};
export default NewCompte;
